import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-column-gap: 2rem;
  margin: 1rem 0;
`;

const Bar = styled.div`
  border-bottom: 1px solid #888;
  align-self: center;
`;

const Text = styled.div`
  color: #888;
  justify-self: center;
`;

export default () => (
  <Container>
    <Bar />
    <Text>or</Text>
    <Bar />
  </Container>
);
